export const HAND_INSURANCE_HOUR_MAX = 24
export const HAND_INSURANCE_PRICE_MAX = 999999.99

export const isHandInsuranceValueValid = (value: string | number) => {
  const numericValue = Number(value)
  return value !== '' && Number.isFinite(numericValue) && numericValue > 0
}

export const isHandInsuranceHourValid = (value: string | number) => {
  const rawValue = String(value)
  const numericValue = Number(rawValue)

  return /^\d+$/.test(rawValue) && numericValue >= 1 && numericValue <= HAND_INSURANCE_HOUR_MAX
}

export const isHandInsurancePriceValid = (value: string | number) => {
  const rawValue = String(value)
  const numericValue = Number(rawValue)

  return (
    /^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(rawValue) &&
    Number.isFinite(numericValue) &&
    numericValue > 0 &&
    numericValue <= HAND_INSURANCE_PRICE_MAX
  )
}

export const resolveHandInsuranceErrorMessage = (
  message: unknown,
  hasTranslation: (key: string) => boolean,
  translate: (key: string) => string
) => {
  const key = typeof message === 'string' ? `HAND_INSURANCE.MESSAGE.${message}` : ''

  return key && hasTranslation(key) ? translate(key) : translate('HAND_INSURANCE.MESSAGE.ERROR')
}
